<template>
  <component
    :is="as"
    class="index-category-card"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <align small-gap>
      <icon :class="['category-icon', { success: highlight }]" :name="icon" />

      <h6 class="secondary-font">{{ text }}</h6>
    </align>

    <align
      v-if="percentChange !== null"
      class="trending"
      :class="{ success: percentChange > 0, error: percentChange < 0 }"
      small-gap
    >
      <span>{{ percentChange > 0 ? '+' : '' }}{{ $filters.percentage(percentChange) }}</span>
      <icon :name="percentChange > 0 ? 'trending_up' : 'trending_down'" />
    </align>
  </component>
</template>

<script>
import Align from './Align';
import Icon from './Icon';

export default {
  components: {
    Align,
    Icon,
  },

  props: {
    as: String,
    icon: String,
    text: String,
    highlight: Boolean,
    percentChange: Number,
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.index-category-card {
  box-shadow: $elevation-1;
  background-color: var(--theme-card);
  border-radius: $border-radius;
  padding: $gp;
  display: flex;
  align-items: center;
  text-decoration: none;
  position: relative;
  overflow: hidden;

  &.large {
    padding: $gp * 2;
  }

  &:hover {
    cursor: pointer;
    background-color: var(--theme-active);
  }

  .category-icon {
    color: var(--theme-icon-button-color);
  }

  h6 {
    margin-bottom: 0;
    color: var(--theme-color);
  }

  .trending {
    margin-left: auto;
    font-weight: bold;
    font-family: $font-family-secondary;
  }
}
</style>
